import * as Yup from 'yup';

const PublicLoanApplicationValidationSchema = Yup.object().shape({
    personalDetail: Yup.object().shape({
        title: Yup.string().required('Title is required'),
        firstName: Yup.string()
            .min(2, 'First name must be at least 2 characters')
            .required('First name is required'),
        surname: Yup.string()
            .min(2, 'Last name must be at least 2 characters')
            .required('Last name is required'),
        email: Yup.string()
            .email('Please enter a valid email address')
            .required('Email is required'),
        mobileNumber: Yup.string()
            .matches(/^[0-9\s\-\+\(\)]{10,15}$/, 'Please enter a valid mobile number')
            .required('Mobile number is required'),
        dateOfBirth: Yup.string()
            .matches(/^(\d{2})\/(\d{2})\/(\d{4})$/, 'Please enter date in DD/MM/YYYY format')
            .test('is-valid-date', 'Please enter a valid date', (value) => {
                if (!value) return false;
                const [day, month, year] = value.split('/').map(Number);
                const date = new Date(year, month - 1, day);
                return date.getDate() === day && 
                       date.getMonth() === month - 1 && 
                       date.getFullYear() === year;
            })
            .test('not-future', 'Date of birth cannot be in the future', (value) => {
                if (!value) return false;
                const [day, month, year] = value.split('/').map(Number);
                const birthDate = new Date(year, month - 1, day);
                const today = new Date();
                today.setHours(0, 0, 0, 0); // Reset time to start of day
                return birthDate <= today;
            })
            .test('minimum-age', 'You must be at least 15 years old', (value) => {
                if (!value) return false;
                const [day, month, year] = value.split('/').map(Number);
                const birthDate = new Date(year, month - 1, day);
                const today = new Date();
                
                // Calculate age
                let age = today.getFullYear() - year;
                const monthDiff = today.getMonth() - (month - 1);
                
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
                    age--;
                }
                
                return age >= 15;
            })
            .required('Date of birth is required'),
        residentialAddress: Yup.object().shape({
            fullAddress: Yup.string().required('Residential address is required')
        })
    }),
    loanDetail: Yup.object().shape({
        purpose: Yup.string().required('Loan purpose is required'),
        amount: Yup.number()
            .transform((value, originalValue) => {
                // Convert empty string to undefined for proper validation
                return originalValue === '' ? undefined : value;
            })
            .typeError('Loan amount must be a number')
            .min(1000, 'Minimum loan amount is $1,000')
            .max(1000000, 'Maximum loan amount is $1,000,000')
            .required('Loan amount is required'),
        term: Yup.string().required('Loan term is required')
    })
});

export default PublicLoanApplicationValidationSchema;